import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
} from "@chakra-ui/react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {useProjectsStore} from "../../store/useProjectsStore.ts";
import ProjectDrawerHeader from "./ProjectDrawerHeader.tsx";
import ProjectDrawerOverview from "./ProjectDrawerOverview.tsx";
import ProjectDrawerOverallProgress from "./ProjectDrawerOverallProgress.tsx";
import ProjectDrawerFeaturesProgress from "./ProjectDrawerFeaturesProgress.tsx";
import useUiStore from "../../store/useUiStore.ts";

interface ProjectDrawerProps {
  projectId: string;
}

const ProjectDrawer: React.FC<ProjectDrawerProps> = (
  {
    projectId,
  }: ProjectDrawerProps) => {
  const {drawer, closeDrawer} = useUiStore()
  const project: IProject | null = useProjectsStore((state) => state.projects.find((p) => p.id === projectId) || null);

  if (!project) return null

  return (
    <Drawer isOpen={drawer.isVisible} placement="right" onClose={closeDrawer} size="lg">
      <DrawerOverlay/>
      <DrawerContent bg="gray.800" borderLeft="1px solid gray.700">
        <DrawerCloseButton color="n.200"/>
        <ProjectDrawerHeader projectId={project.id}/>
        <DrawerBody>
          <div className="flex flex-col">
            <ProjectDrawerOverview project={project} closeDrawer={closeDrawer}/>
            <div className="flex flex-col mt-8 ">
              <ProjectDrawerOverallProgress project={project}/>
              <ProjectDrawerFeaturesProgress project={project}/>
            </div>
          </div>
        </DrawerBody>

        <DrawerFooter borderTop="1px solid gray.700">

        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
    ;
};

export default ProjectDrawer;